<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box no-display" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Get Student Report </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense>
            <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
                <v-radio label="Exam Marksheet" value="exam" color="#0f2027"></v-radio>
                <v-radio label="Annual Marksheet" value="marksheet" color="#0f2027"></v-radio>
            </v-radio-group>
        </v-row>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_ay_data"
                        return-object
                        :items="ay_std_div_list"
                        item-text="ay"
                        label="Select Academic Year"
                        outlined
                        persistent-hint
                        hint="Please select academic year"
                      
                        @change="getassschemedetails();getStd()"
                    />
                    <!-- getassschemedetails();   @click="show = false"-->
                </v-col>
                 <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete dense required outlined rounded color="#0F2027" v-model="sem" :items="semester_list"
                        item-text="sem" item-value="id" label="Semester" persistent-hint
                        hint="Please select semester" />
                </v-col>
              
              
                <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_std_data"
                        return-object
                        :items="std_div_list"
                        item-text="std"
                        label="Standard"
                        outlined
                        @change="
              getDiv();
              
            "
                        persistent-hint
                        hint="Please select standard"
                        
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div"
                     item-value="div_off_id" :items="div_list" item-text="div_name"
                      label="Division" outlined persistent-hint hint="Please select division"
                      @change="
              getStudent();  " />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="radios=='exam'">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        dense
                        required
                        outlined
                        rounded
                        color="#0F2027"
                        v-model="asd"
                        :items="assessment_detail_list"
                        item-text="assessmenttype"
                        item-value="id"
                        return-object
                        label="Assessment Type"
                        persistent-hint 
                        hint="Please select Assessment Type"
                        @click="show = false"
                    />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        v-model="registration_no"
                        rounded
                        color="#0F2027"
                        :items="stud_list"
                        label="Select Student"
                        item-text="name"
                        return-object
                        outlined
                        dense
                        @click="show = false"
                        persistent-hint
                        hint="Please select Student"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && asd && registration_no && radios=='exam'">
                    <v-btn class="mt-6 button" :loading="fecth_gen_btn_loader" @click="getreport2()">Fetch / Generate </v-btn>
                </v-col>
                <v-col cols="12" sm="2" md="2" v-else>
                    <v-btn class="mt-6 button" :loading="fecth_gen_btn_loader" @click="getreport3()">Fetch / Generate </v-btn>
                </v-col>
            </v-row>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "jspdf-autotable";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                default_value: [],
                overlay: false,
                selected: [],
                snackbar: false,
                search: "",
                snackbar_msg: "",
                color: "",
                snackbar: false,
                ay_std_div_list: null,
                semester_list: null,
                sem:null,
                sel_ay_data: null,
                fetch_loader: false,
                show: false,
                stud_list: [],
                registration_no: null,
                awspath: "",
                assessment_detail_list: [],
                asd: null,
                role: null,
                radios:'exam',
                std_div_list: null,
                div_list: null,
                div: null,
                sem: null,
                sel_std_data: null,
                fecth_gen_btn_loader:false,
                orgid:null
            };
        },
        watch: {
            sem() {
                this.registration_no = null;
            },
        },
        methods: {
            getassschemedetails() {
                const data = {
                    ay: this.sel_ay_data.ay_id,
                };
                axios
                    .post("/WWSExamination/getassschemedetailsconfig", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.assessment_detail_list = res.data.assessment_detail_list;
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.msg_flag);
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
                    .finally(() => {
                        this.comp_load = false;
                    });
            },
            putallnull() {
                this.div_list = null;
                (this.assessment_detail_list = []), (this.assessment_detail = null);
            },
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            putnull3() {
                this.show = false;
            },
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            async getreport2() {
               
                localStorage.setItem("setay", this.sel_ay_data.ay_id);
                localStorage.setItem("setstd", this.sel_std_data.std_id);
                localStorage.setItem("setdiv", this.div);
                localStorage.setItem("setasd", this.asd.id);
                localStorage.setItem("setreg_no", this.registration_no.registration_number);
                localStorage.setItem("setsem", this.sem);
                let routeData = this.$router.resolve({
                    name: "sgs-xi-marksheet",
                });
                window.open(routeData.href, "_blank");
            },
            getreport3(){
                localStorage.setItem("setay", this.sel_ay_data.ay_id);
                localStorage.setItem("setstd", this.sel_std_data.std_id);
                localStorage.setItem("setdiv", this.div);
                localStorage.setItem("setreg_no", this.registration_no.registration_number);
                localStorage.setItem("setsem", this.sem);
                // if(this.orgid == 1 || this.orgid == 2 || this.orgid == 3){
                //    let routeData = this.$router.resolve({
                //         name: "sgs-cbse-annual-marksheet",
                //     });
                //     window.open(routeData.href, "_blank");
                // }
                // else{
                    let routeData = this.$router.resolve({
                        name: "sgs-xi-annual-marksheet",
                    });
                    window.open(routeData.href, "_blank");
                //}
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getStudent() {
                this.role = sessionStorage.getItem("para_role");
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    div: this.div,
                    std: this.sel_std_data.std_id,
                    role: this.role,
                };
                axios
                    .post("/sanjivaniExamination/getAllStudents_for_marksheet", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.stud_list = res.data.stud_list;
                            
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
                    .finally(() => {
                        this.comp_load = false;
                    });
            },
            onload() {
                axios
                    .post("/sanjivaniExamination/get_ay_std_divall")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        this.semester_list = res.data.semester_list
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },

            getStd() {
                this.std_div_list = null;
                this.sel_std_data = null;
                this.div_list = null;
                this.div = null;
                this.std_div_list = this.sel_ay_data.std_list;
            },
            getDiv() {
                this.div_list = this.sel_std_data.div_list;
                if (this.div_list.length == 0) {
                    alert("No division found!!!");
                    this.div_list = null;
                }
            },
        },
        mounted() {
            this.onload();
            this.awspath = localStorage.getItem("awspath");
            this.orgid = localStorage.getItem("EPS-org-id");
        },
    };
</script>
<style scoped>
    .text_report {
        border: 3px solid black;
        margin: 1rem !important;
    }
    thead {
        font-weight: bold !important;
    }
    th {
        font-weight: bold !important;
    }
    tr,
    td,
    th {
        border: 1px solid black;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid black;
        border: 1px solid black;
        font-size: small;
    }
    td {
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
    .t-row {
        padding: 1rem i !important;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .delete-avatar {
        transition: 0.3s;
        border: 1px solid red;
        margin: 0.2rem !important;
    }
    .delete-avatar:hover {
        background-color: transparent;
    }
    .delete-v-icon {
        padding-left: 8px;
        padding-top: 1px;
        font-size: 15px;
    }
    .delete-v-icon:hover {
        color: white;
    }
    .v-dialogss {
        bottom: 880;
        right: 0;
    }
    @media print {
        .card {
            border: none !important;
            font-size: large !important;
        }
        .pagebreak {
            page-break-before: always;
        }
        header,
        footer,
        nav,
        date {
            display: none !important;
        }
        table,
        td,
        tr {
            break-inside: avoid-page;
        }
        img {
            width: 100% !important;
        }
        body,
        tr,
        th,
        td {
            font-size: large !important;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        v-card {
            border: none !important;
        }
        @page {
            size: A4;
            margin-top: none;
            padding-top: none;
            size: 15.5in 15.5in;
        }
        thead {
            font-weight: bold !important;
        }
        table,
        td,
        tr,
        th {
            text-align: center !important;
            margin-top: none;
            padding: none !important;
            border-bottom: 1px solid black;
            border: 1px solid black;
        }
    }
    ol.s {
        list-style-type: inherit;
    }
</style>
